import React from "react";

import { useUiState } from "../../lib/UiStates";

const PageHeader = () => {
  const { state: uiState } = useUiState();

  // @TODO handle target environment.
  React.useEffect(() => {
    const ogSiteName = document.querySelector('meta[property="og:site_name"]');
    const siteName = ogSiteName
      ? ogSiteName.getAttribute("content")
      : "Audio Guides";
    document.querySelector("title").innerHTML = [
      uiState.pageTitle,
      uiState.pageParentTitle,
      siteName,
      "State Library of NSW"
    ]
      .filter(x => x && x.length > 0)
      .join(" | ");
  }, [uiState.pageTitle, uiState.pageParentTitle]);

  return [];
};

export default PageHeader;
